import L from 'external/leaflet';

export const stateToValueMap = {
    unknown: 0,
    no: 1,
    green: 1,
    yellow: 2,
    orange: 3,
    red: 4,
    yes: 4
};

export default {
    isMarker(layer) {
        return layer instanceof L.Marker;
    },

    notMarker(layer) {
        return !!layer.getBounds;
    },

    isPolygon(layer) {
        return layer instanceof L.Polygon || layer instanceof L.Rectangle;
    },

    isLine(layer) {
        return layer instanceof L.Polyline;
    },

    getFeatureRendererDependency(feature){
        return 'FeatureRenderer/' + (feature.properties && feature.properties.type);
    }
};

export function getFeature(layer, newGeometry){
    return layer.feature ?
        L.Util.extend({}, layer.feature, { geometry: newGeometry }) :
        asFeature(newGeometry);
}

export function asFeature(geojson){
    if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
        return geojson;
    }

    return {
        type: 'Feature',
        properties: {},
        geometry: geojson
    };
}



// WEBPACK FOOTER //
// ./js/utils/feature-util.js